module.exports = __webpack_public_path__ + "static/media/building-plan.a9e74fac.jpg";